import { FilterBkgColor } from '../Filters/FilterBkgColor';
import { DisneylandParisSVG } from '../Document/DisneylandParisSVG.js';

export const Jumbotron = (props) => {
    const bkg = FilterBkgColor();
    const datas = props.datas;
    return (
        <section className={`jumbotron ${bkg}`}>
            <DisneylandParisSVG />
            <div className="statistiques">
                {datas.map((item, i) => {
                    return (<div key={i}>{item.label}</div>)
                })}
            </div>
        </section>
    )
}